import { render, staticRenderFns } from "./appstore.vue?vue&type=template&id=09c94e1a&"
import script from "./appstore.vue?vue&type=script&lang=js&"
export * from "./appstore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports